import React from 'react';
import { useParams } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import KycForm from '../../components/forms/KycForm/KycForm';

const KycPage = () => {

  const { uid } = useParams();

  return (
    <AuthLayout pageName="user-kyc">
      <KycForm idToken={uid} />
    </AuthLayout>
  );
};

export default KycPage;
